import api from "./api";

// 开奖信息列表页
export const postLotteryList = params => {
  return api('post', `/v1/management/lottery/list`, params);
};

// 开奖
export const lotteryUserLottery = (params) => {
  return api('post', `/v1/management/lottery/userLottery`, params);
};

// 获取关联活动列表
export const getLinkEvents = params => {
  return api("get", `/v1/management/lottery/associated-activity/${params}`);
};

// 查询抽奖信息
export const getLotteryDetails = params => {
  return api("get", `/v1/management/lottery/detail/${params}`);
};

// 存入抽奖信息
export const addLottery = params => {
  return api('post', `/v1/management/lottery/add`, params);
};

// 修改抽奖信息
export const updateLottery = params => {
  return api('post', `/v1/management/lottery/update`, params);
};

// 删除抽奖信息
export const delLottery = params => {
  return api("get", `/v1/management/lottery/delete/${params}`);
};

// 公示获奖名单
export const publiclyLottery = params => {
  return api("get", `/v1/management/lottery/publiclyAnnounceTheListOfWinners/${params}`);
};

// 下载中奖名单
export const lotteryDownload = (id) => {
  return api('get', `/v1/management/lottery/lotteryDownload/${id}`,
    {},
    {
      responseType: "blob",
    }
  );
};
